/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import {
  getFilterContracts,
  updateContract,
} from "../../../actions/contract-actions";
import { useStateValue } from "../../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../../utils/form/modalConfirmBase";
import {
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import { getMaestras } from "../../../actions/maestras-actions";
import { getActiveContractTypeFormat } from "../../../actions/clauses-actions";
import Search from "../../../componentes/searchContracts/search";
import AccordionContracts from "../../../componentes/searchContracts/accordionContracts";
import SearchImage from "../../../images/icons/search.svg";
import { ERROR_MESSAGE } from "../../../constants";
import { permissionsConstans } from "../../../constansPermissions";
import utils from "../../../utils/utils";

const Contracts = (props) => {
  const [{ filterContract}, dispatch] =
    useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [permissionContract, setPermissionContract] = useState([]);
  const [maestras, setMaestras] = useState({
    motivoCierreVacante: [],
    tipoContrato: [],
    tipoDocumnetoIdentificacion: [],
  });
  const [contractTypeFormat, setContractTypeFormat] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
  });
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
    isAnularContract: false
  });

  const [filter, setFilter] = useState({
    employeeName: null,
    employeeSurname: null,
    document: null,
    documentType: null,
    contractType: null,
    initContractDate: null,
    endDate: null,
    status: null,
  });
  const [refresh, setRefresh] = useState(false);

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response.data.maestras);
    };
    getListaMaestras();
    const getActiveContractList = async () => {
      const response = await getActiveContractTypeFormat();
      setContractTypeFormat(response.data);
    };
    getActiveContractList();
  }, []);

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const getContracts = async () => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);

    const response = await getFilterContracts(
      {
        initContractDate: filter.initContractDate,
        endContractDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        employeeName: filter.employeeName === "" ? null : filter.employeeName,
        employeeSurname: filter.employeeSurname === "" ? null : filter.employeeSurname,
        document: filter.document === "" ? null : filter.document,
        documentType: filter.documentType === "" ? null : filter.documentType,
        idContractType: filter.contractType === "" ? null : filter.contractType,
        status: filter.status === "" ? null : filter.status,
        regionalId: filter.regional === "" ? null : filter.regional,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );

    if (response) {
      const data = response?.data?.contractPage;
      if (data?.content?.length > 0) {
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    getContracts();
  }, [paginadorRequest, refresh]);

  if (
    filterContract &&
    filterContract?.isFilter &&
    filter !== filterContract.filter
  ) {
    var newfilter = filterContract.filter;
    filter.initContractDate = newfilter.initContractDate;
    filter.endDate = newfilter.endDate;
    filter.employeeName = newfilter.employeeName;
    filter.employeeSurname = newfilter.employeeSurname;
    filter.document = newfilter.document;
    filter.documentType = newfilter.documentType;
    filter.contractType = newfilter.contractType;
    filter.status = newfilter.status;
    filter.regional = newfilter.regional;

    paginadorRequest.page = 0;
    getContracts();
    dispatch({
      type: "SET_CONTRACT_FILTER",
      isFilter: false,
    });
  }

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const anularContractConfirm = (id) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro que desea anular el contrato?",
      handleClick: (comm) => actualizarEstadoContract(id, comm),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: true,
      isAnularContract: true
    }));
  };

  const actualizarEstadoContract = async (id, comments) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isAnularContract: false
    }));
    var cancelData = {
      contractId: id,
      observation: comments,
    };
    const response = await updateContract(cancelData, dispatch);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      setIsLoading(false);
      setMessage({
        open: true,
        question: "Contrato anulado correctamente",
        type: "SUCCESS",
        oneButtons: true,
        handleClick: closeMessage,
      });
      getContracts();
    } else {
      setIsLoading(false);
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: response?.data?.detail
            ? response?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  useEffect(() => {
    const responsePermission = utils.validationPermissions('CON');
    setPermissionContract(responsePermission);
  }, [])
  
  const validationPermissionSearch = () => {
    if (permissionContract?.functionalities?.some((x) => x === permissionsConstans.CON_CONSULTAR)) {
      return <Search contractType={contractTypeFormat} />;
    }
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestión de contratos",
      breadCrumbSubText: "Gestión de contratos",
      pathContarct: `contract/generate-contract`,
      index: 17
    });
  }, []);

  return (
    <div style={{ marginTop: "15px" }}>
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalConfirmBase
        oneButtons={message.oneButtons}
        open={message.open}
        description={message.question}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />

      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
        isAnularContract={confirm.isAnularContract}
      />
      {validationPermissionSearch()}
      {paginadorResponse.data.map((row, index) => (
        <AccordionContracts
          headers={headers}
          data={row}
          maestras={maestras}
          contractType={contractTypeFormat}
          cancelContract={anularContractConfirm}
          permissionContract={permissionContract}
          setRefresh={setRefresh}
          refresh={refresh}
          history={props.history}
          //onView={verRequisicion}
          // onApply={applyVacantConfirm}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={SearchImage} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Contracts);
